import styled from '@emotion/native';
import { Row } from 'components/base';
import { Card as BaseCard, Text } from 'design-system/base';
import { MARGIN } from 'design-system/theme';
import type React from 'react';
import type { PropsWithChildren } from 'react';

type CardProps = PropsWithChildren<{
  title: string;
}>;

const ContentWrapper = styled(Row)({
  marginTop: MARGIN.s,
});

export const Card: React.FC<CardProps> = ({ title, children }) => (
  <BaseCard border>
    <Row>
      <Text variant="heading">{title}</Text>
    </Row>
    <ContentWrapper>{children}</ContentWrapper>
  </BaseCard>
);
